import { DESIGN_H, DESIGN_W } from '../app/theme';

// Leave extra room for the rotated outer corners of a tall, fully fanned Blackjack hand.
export const BLACKJACK_HAND_MAX_WIDTH = DESIGN_W - 40;
export const BLACKJACK_SCORE_PILL_Y = 118;
export const BLACKJACK_INFO_PILL_Y = 166;
export const BLACKJACK_INFO_PILL_H = 40;
export const BLACKJACK_ACTION_TRAY_H = 168;
export const BLACKJACK_VALUE_CHIP_OFFSET = 70;

const CARD_W_BASE = 116;
const OPP_CARD_W_BASE = 94;

const OPP_HAND_Y = 238;
const BET_BOX_Y = 540;
const MY_HAND_Y = 1030;
const ACTION_TRAY_Y = 790;
const RAIL_REFRESH_Y = 520;
const RAIL_CHAT_Y = 610;

const clamp = (v: number, lo: number, hi: number): number => Math.max(lo, Math.min(hi, v));

export interface BlackjackLayout {
  cardW: number;
  oppCardW: number;
  oppHandY: number;
  betBoxY: number;
  myHandY: number;
  trayY: number;
  railRefreshY: number;
  railChatY: number;
}

/**
 * Computes Blackjack's responsive portrait layout. The local, face-up hand is the visual focus;
 * the opponent's hidden backs remain smaller, and the extra height is shared between the table
 * bands while the action tray and local hand stay pinned to the bottom edge.
 */
export function computeBlackjackLayout(viewportHeight: number): BlackjackLayout {
  const drop = Math.max(0, viewportHeight - DESIGN_H);
  const responsiveScale = clamp(viewportHeight / DESIGN_H, 1, 1.25);
  const middleDrift = Math.round(drop * 0.42);
  const opponentDrift = Math.round(drop * 0.3);

  return {
    cardW: Math.round(CARD_W_BASE * responsiveScale),
    oppCardW: Math.round(OPP_CARD_W_BASE * responsiveScale),
    oppHandY: OPP_HAND_Y + opponentDrift,
    betBoxY: BET_BOX_Y + middleDrift,
    myHandY: MY_HAND_Y + drop,
    trayY: ACTION_TRAY_Y + drop,
    railRefreshY: RAIL_REFRESH_Y + middleDrift,
    railChatY: RAIL_CHAT_Y + middleDrift,
  };
}
